import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const done = useRef(false);

    useEffect(() => {
        if (done.current) return;
        done.current = true;

        const hash = location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/admin", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                localStorage.setItem("kabir_admin_token", data.token);
                // strip hash so we don't reprocess and redirect into the dashboard
                window.history.replaceState({}, document.title, "/admin/dashboard");
                toast.success(`Signed in as ${data.email}`);
                // Full reload so AdminAuthProvider re-reads the token and verifies.
                window.location.replace("/admin/dashboard");
            } catch (err) {
                toast.error(err?.response?.data?.detail || "Google sign-in not allowed");
                navigate("/admin", { replace: true });
            }
        })();
    }, [location.hash, navigate]);

    return (
        <div className="min-h-screen grid place-items-center" data-testid="auth-callback">
            <div className="text-center">
                <div className="font-mono text-xs uppercase tracking-[0.25em] text-[hsl(var(--muted-foreground))]">Signing you in</div>
                <div className="font-display text-2xl mt-3">One moment…</div>
            </div>
        </div>
    );
}
